import React from 'react';
function Security({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M5 4h14v5.884a11.12 11.12 0 0 1-1.977 6.092A11.28 11.28 0 0 1 11.998 20a11.28 11.28 0 0 1-5.022-4.024A11.12 11.12 0 0 1 5 9.884V4Z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M9 10.75 11.625 13 16 9"
      />
    </svg>
  );
}

export default Security;
